<template>
	<div>
		<ul class="tabs">
			<li>
				<RouterLink :to="{ name: 'PersonGroups', params: { customerid: this.$route.params.customerid, agreementid: this.$route.params.agreementid }}">
					Grupper
				</RouterLink>
			</li>
			<li>
				<RouterLink :to="{ name: 'Persons', params: { customerid: this.$route.params.customerid, agreementid: this.$route.params.agreementid }}">
					Personer
				</RouterLink>
			</li>
			<li>
				<RouterLink :to="{ name: 'Files', params: { customerid: this.$route.params.customerid, agreementid: this.$route.params.agreementid }}">
					Filer
				</RouterLink>
			</li>
		</ul>
		<transition name="fade">
			<RouterView v-bind:search="search" v-bind:section="'customer'" />
		</transition>
	</div>
</template>

<script>
	import { types } from "@/app/types/types";

	export default {
		name: "CustomersList",
		data: () => ({
		}),
		props: ["search"]
	}
</script>
